var GLOSSARY_TERMS_URL = "/cmscontents/glossaryterms";
var terms;

export default {
    fetch: function (callback) {
        if (terms) {
            return callback(terms);
        }
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var response = JSON.parse(xhr.response);
                    if (!response || !response.glossaryTerms) {
                        return;
                    }
                    terms = response.glossaryTerms;
                    callback(terms);
                } else {
                    console.error(xhr);
                }
            }
        };

        xhr.open("GET", GLOSSARY_TERMS_URL, true);
        xhr.send(null);
    }
};


// WEBPACK FOOTER //
// ./src/js/cms/commons/clientCustomizer/Glossary/GlossaryTerms.js